import React from "react";

const ElearningSolutions = () => {
  return (
    <>
      <div
        className="inner-page"
        id="nodejs-design-bg"
        data-aos="fade-up"
        data-aos-duration={1500}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div
                className="inner_content"
                data-aos="fade-up"
                data-aos-duration={2000}
              >
                <h1>e-Learning Solutions</h1>
                <div aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="index.html">
                        <i className="ri-home-4-line" />
                        Home
                      </a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      e-Learning Solutions
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="section" data-aos="fade-up" data-aos-duration={1500}>
        <div className="bg-body-tertiary">
          <div className="container py-3 py-lg-4">
            <div className="row align-items-center">
              <div className="col-md-7">
                <h2 className="section-title">
                  The Salient Features of the eLearning Solutions Software{" "}
                </h2>
                <div className="d-flex align-items-center">
                  <i className="ri-pencil-ruler-line icon-color mr-3" />
                  <h5>
                    Quick Enrolment Process with Online Software for Training
                  </h5>
                </div>
                <p className="">
                  The students or trainees can enrol into any of the
                  courses/batches as per their convenience and make payments on
                  the portal offering online software for training. On the other
                  hand, you can make use of the portal’s bulk enrolment facility
                  and admit students in large numbers for specific
                  courses/batches.
                </p>
                <div className="text-center text-md-left ">
                  <a href="contact.html" className="btn1 mb-2 mb-lg-0">
                    Request a quote
                  </a>
                  <button className="btn1">Case Study</button>
                </div>
              </div>
              <div className="col-md-5">
                <div className="bg-dotted">
                  <img
                    src="assets/image/desktop.png"
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="section bg_color "
        data-aos="fade-up"
        data-aos-duration={1500}
      >
        <div className="container py-3 py-lg-4">
          <div className="row align-items-center">
            <div className="col-md-4">
              <div className="solutions-image">
                <img
                  src="https://www.webguru-india.com/assets/images/learning-management-system-courses.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="text-white">
                <h5 className="mb-3 ">
                  <img
                    width={64}
                    height={64}
                    src="https://img.icons8.com/external-flatart-icons-outline-flatarticons/64/ffffff/external-graduation-hat-high-school-flatart-icons-outline-flatarticons.png"
                    className="mr-3"
                    alt="external-graduation-hat-high-school-flatart-icons-outline-flatarticons"
                  />
                  Courses
                </h5>
                <p>
                  The state-of-the-art Learning Management System provides you
                  with the facility of uploading course materials in the form of
                  engaging videos and PDFs pertaining to any subject or training
                  module. The course materials can be easily managed at your end
                  through additions, deletions, or modifications. A student or
                  trainee can visit the relevant section(s) of the eLearning
                  solutions portal and access course materials for which he or
                  she has enrolled.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section " data-aos="fade-up" data-aos-duration={1500}>
        <div className="container py-3 py-lg-4">
          <div className="row align-items-center flex-row-reverse">
            <div className="col-md-4">
              <div className="solutions-image">
                <img
                  src="https://www.webguru-india.com/assets/images/learning-management-system-class-schedule.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="">
                <div className="d-flex align-items-center">
                  <i className="fa fa-calendar icon-color mr-3" />
                  <h5 className="">
                    {" "}
                    Setup Class Schedule with Online Training Software
                  </h5>
                </div>
                <p>
                  The eLearning website allows you to set up the class schedule
                  for various courses or training programmes. For online
                  classes, the students or trainees can visit the relevant
                  section of the eLearning solutions portal and find out details
                  of the classes. The online training software suite gives users
                  the facility of accessing the video recordings of all
                  courses/training programs irrespective of the
                  day/week/month/year
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="section bg_color "
        data-aos="fade-up"
        data-aos-duration={1500}
      >
        <div className="container py-3 py-lg-4">
          <div className="row align-items-center">
            <div className="col-md-4">
              <div className="solutions-image">
                <img
                  src="https://www.webguru-india.com/assets/images/learning-management-system-assessment.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="text-white">
                <h5 className="mb-3">
                  <img
                    width={50}
                    height={50}
                    src="https://img.icons8.com/ios/50/ffffff/pass.png"
                    className="mr-3"
                    alt="pass"
                  />
                  Assessment
                </h5>
                <p>
                  Evaluation forms an important part of any training or learning
                  programme and offers an insight into the level of
                  understanding of the students/trainees. As one of the
                  prominent eLearning website features, the assessment module
                  completes the cycle of learning. You can upload and manage the
                  assessments for any course/subject/training program in both
                  MCQ and subjective formats. The assessments in the MCQ format
                  deliver results immediately. The module comprises features
                  such as data validation, number of attempts, timer, report
                  generation and skip ability. It allows you to create question
                  banks and upload bulk questions as well.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section " data-aos="fade-up" data-aos-duration={1500}>
        <div className="container py-3 py-lg-4">
          <div className="row align-items-center flex-row-reverse">
            <div className="col-md-4">
              <div className="solutions-image">
                <img
                  src="https://www.webguru-india.com/assets/images/learning-management-system-specialists-guidance.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="">
                <h5 className="mb-3">
                  <img
                    width={50}
                    height={50}
                    src="https://img.icons8.com/sf-ultralight-filled/50/0d6efd/chat.png"
                    className="mr-3"
                    alt="chat"
                  />
                  Specialists’ Guidance from Software for Online Teaching
                </h5>
                <p>
                  Our innovative and comprehensive eLearning services let the
                  students/trainees get their queries resolved by contacting the
                  subject matter experts within timelines. This feature makes
                  the eLearning management system interactive and user friendly.
                  The modus operandi of the software for online teaching is
                  simple – students or trainers log their queries on the
                  specified section while the subject matter experts analyze the
                  same and post responses in a swift and timebound manner.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="section  bg_color"
        data-aos="fade-up"
        data-aos-duration={1500}
      >
        <div className="container py-3 py-lg-4">
          <div className="row align-items-center">
            <div className="col-md-4">
              <div className="solutions-image">
                <img
                  src="https://www.webguru-india.com/assets/images/learning-management-system-customization.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="">
                <div className="d-flex align-items-center">
                  <i className="fa fa-cogs icon-color-white mr-3" />
                  <h5 className="">Customization</h5>
                </div>
                <p>
                  Each organization has its own scholastic or business goals.
                  Our visually attractive, engaging, and highly interactive
                  eLearning website design lets you create your eLearning
                  strategy, curriculum, or storyboards for any course, subject
                  or training programme. We create and host the eLearning
                  solutions website exclusively for your organization, one that
                  reflects its look, feel and essence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section " data-aos="fade-up" data-aos-duration={1500}>
        <div className="container py-3 py-lg-4">
          <div className="row align-items-center flex-row-reverse">
            <div className="col-md-4">
              <div className="solutions-image">
                <img
                  src="https://www.webguru-india.com/assets/images/learning-management-system-userfriendly.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="">
                <h5 className="mb-3">
                  <img
                    width={66}
                    height={66}
                    src="https://img.icons8.com/external-3d-design-circle/66/external-Admin-Panel-design-and-development-3d-design-circle.png"
                    alt="external-Admin-Panel-design-and-development-3d-design-circle"
                  />{" "}
                  Easy to use Admin Panel
                </h5>
                <p>
                  Our innovative and comprehensive eLearning services let the
                  students/trainees get their queries resolved by contacting the
                  subject matter experts within timelines. This feature makes
                  the eLearning management system interactive and user friendly.
                  The modus operandi of the software for online teaching is
                  simple – students or trainers log their queries on the
                  specified section while the subject matter experts analyze the
                  same and post responses in a swift and timebound manner.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="section bg_color  after-image overflow-hidden"
        data-aos="fade-up"
        data-aos-duration={1500}
      >
        <div className="container py-3 py-lg-4">
          <div className="row align-items-center">
            <div className="col-md-5">
              <div className="mobile-friendly-image solutions-image">
                <img
                  src="https://www.webguru-india.com/assets/images/learning-management-system-mobile-friendly.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-7">
              <div className="text-white">
                <h5 className="mb-3">
                  <img
                    width={50}
                    height={50}
                    className="mr-3"
                    src="https://img.icons8.com/ios/50/ffffff/media-queries.png"
                    alt="media-queries"
                  />
                  Mobile Friendly
                </h5>
                <p>
                  In a day and age where mobiles play an important role in
                  disseminating information or provisioning services, the
                  features of our eLearning solutions website can be easily
                  accessed from a mobile platform. This helps the tech savvy
                  students or trainees to keep in touch with the learning or
                  training programmes on the go.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section " data-aos="fade-up" data-aos-duration={1500}>
        <div className="container py-3 py-lg-4">
          <div className="row align-items-center flex-row-reverse">
            <div className="col-md-4">
              <div className="solutions-image">
                <img
                  src="https://www.webguru-india.com/assets/images/learning-management-system-report-generation.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="">
                <h5 className="mb-3">
                  <img
                    width={60}
                    height={60}
                    className="mr-3"
                    src="https://img.icons8.com/color/60/combo-chart--v1.png"
                    alt="combo-chart--v1"
                  />
                  Report Generation
                </h5>
                <p>
                  Each and every segment of the eLearning portal is capable of
                  generating a comprehensive report to help you study and
                  analyze the performance level of students/trainees, list of
                  courses, number of students enrolled etc. The reports
                  generated by the software for online teaching provide an
                  insight into the progress of students/trainees undergoing
                  various courses or training programmes as part of the
                  eLearning management system.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="section  mb-10 py-3 py-lg-4"
        data-aos="fade-up"
        data-aos-duration={1500}
      >
        <div className="container">
          <h2 className="section-title-2 mb-10">
            Achieve Your Business Objectives With Our Robust Elearning Solution
          </h2>
          <p>
            To facilitate the learning or training of students/trainees and
            expand your business, avail our feature-rich, highly interactive,
            and ready to use eLearning solution. We also customize the learning
            management system according to the theme and needs of your business.
          </p>
          <div className="text-center">
            <button className="btn1 mb-2 mb-lg-0">Feature List</button>
            <button className="btn1">Live Demo</button>
          </div>
        </div>
      </section>
    </>
  );
};

export default ElearningSolutions;
